export default {
  pageNavbar: [
    {
      name: "Kontrola Jazdy",
      anchor: "drive-control"
    },
    {
      name: "S-AWC",
      anchor: "S-AWC"
    },
    {
      name: "Tryb jazdy",
      anchor: "drive-mode"
    },
    {
      name: "Więcej",
      anchor: "more"
    },
    {
      name: "Inne",
      anchor: "features"
    }
  ],
  headerDesc:
    "Dla Eclipse Cross PHEV każde życzenie kierowcy jest rozkazem. Napęd Twin Motor 4WD z systemem S-AWC przekazuje moment obrotowy niezależnie na przednią i tylną oś, a Ty zyskujesz poczucie pełnego panowania nad drogą. Dwa silniki elektryczne zapewniają doskonałą trakcję, a przełącznik DRIVE MODE pozwala dopasować charakterystykę ich pracy do warunków na drodze i preferencji kierowcy.",
  headerButton: "Zobacz wideo",
  textWitVideoSubHeader: "S-AWC",
  textWitVideoHeader: "Super all wheel control",
  textWitVideoDesc:
    "Napęd na 4 koła S-AWC to szczytowe osiągnięcie inżynierów Mitsubishi Motors rozwijane od lat w sporcie samochodowym. W Mitsubishi Eclipse Cross PHEV można spotkać najnowszą odmianę tego systemu. Dwa silniki elektryczne sprzężone z system aktywnej kontroli znoszenia (AYC), systemem ABS oraz aktywną kontrolą trakcji i stabilizacji toru jazdy (ASTC) zapewniają nie tylko niezrównany poziom bezpieczeństwa, ale gwarantują również doskonałe właściwości jezdne.",
  textWitVideoButton: "Zobacz wideo",
  driveModeSubHeader: "Kontrola jazdy",
  driveModeHeader: "Tryb jazdy dostosowany do drogi",
  driveModeButton: "Zobacz wideo",
  advancedSubHeader: "Zaawansowane technologie",
  advancedHeader: "Więcej",
  advancedEasy: "Spoiwo strukturalne",
  advancedEasyDesc:
    "Warstwy łączenia strukturalnego na drzwiach i pokrywie bagażnika zwiększają sztywność połączeń między panelami nadwozia w celu zwiększenia stabilności kierowania.",
  advancedMode: "Dopracowany układ jezdny",
  advancedModeDesc:
    "Tylne amortyzatory o większej średnicy oraz przednie kolumny MacPhersona o zmodyfikowanej charakterystyce poprawiają komfort i precyzję prowadzenia.",
  advancedImages: ["advanced-image-first.png", "advanced-image-second.png"],
  footerSlider: [
    {
      header: "TRYB NORMAL",
      description: "Drogi asfaltowe.",
      background: "TRYB_NORMAL.png"
    },
    {
      header: "TRYB TARMAC",
      description: "Kręte drogi asfaltowe.",
      background: "TRYB_TARMAC.png"
    },
    {
      header: "TRYB GRAVEL",
      description: "Nawierzchnie luźne np. szuter.",
      background: "TRYB_GRAVEL.png"
    },
    {
      header: "TRYB SNOW",
      description: "Drogi pokryte śniegiem.",
      background: "TRYB_SNOW.png"
    }
  ]
};
